import { createCommand } from '../../utils';
import { filterUpdated, moduleName } from '../state';
import type { NetworkSectionFilter } from '../../domain/Network';

const FilterNetworkCommand = createCommand(
    `${moduleName}/FILTER_NETWORK`,
    async (filter: NetworkSectionFilter, { dispatch, extra }) => {
        extra.externalNetworkConfiguration.saveNetworkSectionsFilter(filter);
        dispatch(filterUpdated(filter));
    },
);

export default FilterNetworkCommand;
